var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"vid":_vm.vid,"name":_vm.$attrs.name || _vm.$attrs.label,"rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
var validated = ref.validated;
var valid = ref.valid;
return [_c('b-field',_vm._b({staticClass:"validator-field",class:_vm.fieldClass,attrs:{"type":{
      'is-danger': errors[0] && _vm.showError,
      'is-success': validated && valid && _vm.showSuccess,
    },"message":errors}},'b-field',_vm.$attrs,false),[_c('b-input',_vm._b({ref:"innerInput",attrs:{"value":_vm.displayedValue},on:{"input":_vm.setInnerValue,"blur":_vm.blur}},'b-input',_vm.$attrs,false))],1),_vm._t("default")]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }